"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const objectUtils_1 = __importDefault(require("@utils/objectUtils"));
const react_1 = __importDefault(require("react"));
require("./style.scss");
const TableCell = (props) => {
    const { className = '', onClick, children, dataStopProp, grow, contentType = '', id, isResizeHandleShow, tableHeight, isInsideModal = false } = props;
    const [currentResizeColumn, setCurrentResizeColumn] = react_1.default.useState(null);
    const [originalColumnWidth, setOriginalColumnWidth] = react_1.default.useState({
        targetElement: null,
        adjacentElement: null
    });
    const [isResizeTargetCell, setIsResizeTargetCell] = react_1.default.useState(false);
    const isFirstRender = react_1.default.useRef(true);
    const tableElement = document.querySelector(`${isInsideModal ? '.modal__wrapper .table__wrapper' : '.table__wrapper'}`);
    const handleOnClick = (event) => {
        const element = event.target;
        if (element.getAttribute('data-stop-prop'))
            return;
        if (onClick)
            onClick(event);
    };
    const handleMouseDown = (id) => {
        setCurrentResizeColumn(id);
        const targetElement = document.querySelector(`[data-column-id="${id}"]`).querySelector('#container');
        const adjacentElement = targetElement.parentNode.nextElementSibling.querySelector('#container');
        setOriginalColumnWidth({
            targetElement: targetElement.offsetWidth,
            adjacentElement: adjacentElement.offsetWidth
        });
    };
    const handleMouseMove = (event) => {
        if (currentResizeColumn !== id)
            return;
        const minWidth = 40;
        const targetCells = document.querySelectorAll(`[data-column-id="${id}"]`);
        const { left: targetCellLeftPosition } = targetCells[0].getBoundingClientRect();
        const targetNewWidth = event.clientX - targetCellLeftPosition;
        const targetWidthShift = targetNewWidth - originalColumnWidth.targetElement;
        const adjacentNewWidth = originalColumnWidth.adjacentElement - targetWidthShift;
        if (targetNewWidth < minWidth || adjacentNewWidth < minWidth)
            return;
        targetCells.forEach((element) => {
            const targetElement = element.querySelector('#container');
            const adjacentElement = targetElement.parentNode.nextElementSibling.querySelector('#container');
            targetElement.style.width = `${targetNewWidth}px`;
            adjacentElement.style.width = `${adjacentNewWidth}px`;
        });
    };
    const removeListeners = () => {
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
    };
    const handleMouseUp = () => {
        setCurrentResizeColumn(null);
        removeListeners();
    };
    react_1.default.useEffect(() => {
        if (objectUtils_1.default.isExist(currentResizeColumn)) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        }
        return () => {
            removeListeners();
        };
    }, [currentResizeColumn, handleMouseMove, handleMouseUp, removeListeners]);
    react_1.default.useEffect(() => {
        const allTableCells = document.querySelectorAll('.table__cell_childrenContainer');
        allTableCells.forEach((element) => {
            element.style.width = '';
        });
    }, []);
    react_1.default.useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        // 修正 Cannot read property 'style' of null
        if (tableElement) {
            if (currentResizeColumn === id) {
                tableElement.style.userSelect = 'none';
                tableElement.style.pointerEvents = 'none';
                return setIsResizeTargetCell(true);
            }
            tableElement.style.userSelect = 'auto';
            tableElement.style.pointerEvents = 'auto';
        }
        setIsResizeTargetCell(false);
    }, [currentResizeColumn]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `table__cell${grow ? ` flex-grow-${grow}` : ''}${contentType ? ` table__cell_${contentType}` : ''} ${className} ${id}`, onClick: handleOnClick, "data-stop-prop": dataStopProp, "data-column-id": id, id: id }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "table__cell_childrenContainer", id: "container" }, { children: children })), isResizeHandleShow && ((0, jsx_runtime_1.jsx)("div", { style: { height: tableHeight }, className: `resize-handle ${isResizeTargetCell ? 'showHighlight' : ''}`, onMouseDown: () => handleMouseDown(id) }))] })));
};
exports.default = TableCell;
